import { all, put, takeLatest, call, select } from 'redux-saga/effects';
import { getItem, removeItem, setItem } from '../../../utils/cache';
import {
  DO_SIGNUP_REQUEST,
  DO_LOGIN_REQUEST,
  DO_LOGOUT_REQUEST,
  VERIFY_OTP_REQUESTED,
  DO_OTP_RESEND_REQUEST,
  DO_WAITLIST_SURVEY_REQUEST,
  DO_SURVEY_REQUEST,
  DO_APPLE_SIGNIN_REQUEST,
  DO_UPDATE_EMAIL_WITH_OTP_REQUEST,
  DO_VERIFY_OTP,
  DO_SEND_OTP_REQUEST,
  DO_VERIFY_RESET_PASS_OTP,
  DO_RESET_PASSWORD_REQUEST,
  DO_MERGE_SEND_OTP_REQUEST,
  DO_VERIFY_OTP_AND_MERGE_ACCOUNTS,
} from '../../constant/auth';
import {
  doSignupSuccess,
  doSignupFailed,
  verifyOtpSuccess,
  verifyOtpFailed,
  doLoginSuccess,
  doLoginFailed,
  doOtpResendSuccess,
  doSurveySuccess,
  doWaitlistSurveySuccess,
} from '../../action/auth';
import { setLoadingState, setUniversalLoading } from '../../action/common';
// import { doPlaybackHistoryRequest, setLoadingState } from '../../action/common';
import {
  loginPostRequest,
  signupPostRequest,
  otpPostRequest,
  otpResendPostRequest,
  surveyPostRequest,
  appleSignInRequest,
  // onboardingCompleteRequest,
  UpdateMobileWithOtpRequest,
  VerifyOtp,
  ResetPassOtpRequest,
  verifyResetOtp,
  resetPassword,
  mergeOtpPostRequest,
  handleverifyOtpMergeAccounts,
} from '../../../api/auth';
import { waitlistSurveyGetRequest } from '../../../api/waitlistSurvey';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../../../services/Notification';
import { SURVEY_STATUS, LOCAL_STORAGE_CONSTANT } from '../../../constants/app';
import { errorHandler } from '../../../utils/helpers';
import { extractJSON } from '../../../services/jsonUtil';
import { updateUserProfileRequest } from '../../../api/user';
// import { doGetUserDataSuccess } from '../../action/user';

// select Was also used in 1st import

/**
 * Get tournament details by Id Request
 * */
function* signupRequest({
  payload: { data, callback, page, errorCallback = () => {} },
}) {
  try {
    const response = yield call(signupPostRequest, data);
    yield put(doSignupSuccess({ data: response?.data?.response?.data, page }));
    if (callback) {
      callback();
    }
    // createNotification({
    //   type: NOTIFICATION_TYPE.SUCCESS,
    //   message: 'Verification Code Sent Successfully !',
    // });
  } catch (e) {
    doSignupFailed({
      error: e,
      page,
    });
    createNotification(errorHandler(e));
    if (errorCallback) {
      errorCallback(e);
    }
  } finally {
    yield put(setLoadingState(false));
  }
}

function* loginRequest({ payload: { data, callback, page } }) {
  try {
    const response = yield call(loginPostRequest, data);
    yield put(
      doLoginSuccess({
        data: response?.data?.response?.data,
        page,
      }),
    );
    if (callback) {
      callback(response);
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Verification Code Sent Successfully !',
    });
  } catch (e) {
    doLoginFailed({
      error: e,
      page,
    });
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* UpdateMobileOtpRequest({ payload: { data, callback, page } }) {
  try {
    const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    const response = yield call(UpdateMobileWithOtpRequest, data);
    setItem('PhoneDetails', JSON.stringify(data)); // Set Phone details in localstorage to be used in OTP Modal
    const newData = {
      ...response?.data?.response?.data,
    };
    newData.attributes.new_user = user?.attributes?.new_user;
    newData.attributes.country_code = '';
    newData.attributes.mobile = '';
    yield put(doSignupSuccess({ data: newData, page }));
    setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(newData));
    if (callback) {
      callback();
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Verification Code Sent Successfully !',
    });
  } catch (e) {
    doSignupFailed({
      error: e,
      page,
    });
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* otpVerifyRequest({
  payload: { data, callback, errorCallback, page },
}) {
  try {
    // const urlParams = new URLSearchParams(window.location.search);
    // // const provider = urlParams.get('provider');
    // // const isAppleLogin = getItem('isAppleLogin');

    const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
    const phoneDetails = JSON.parse(getItem('PhoneDetails'));
    // if (!(provider || isAppleLogin)) {
    //   session.uid = (
    //     (user?.attributes?.country_code || phoneDetails?.country_code) +
    //     (user?.attributes?.mobile || phoneDetails?.mobile)
    //   ).slice(1);
    //   setItem(
    //     LOCAL_STORAGE_CONSTANT.SESSION,
    //     JSON.stringify({ ...session, uid: session.uid }),
    //   );
    // }
    const response = yield call(VerifyOtp, data);
    yield put(doSignupSuccess({ data: response?.data?.response?.data, page }));
    const newData = {
      ...response?.data?.response?.data,
    };
    newData.attributes.new_user = user?.attributes?.new_user;
    setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(newData));
    session.uid = (
      (user?.attributes?.country_code ||
        phoneDetails?.country_code ||
        newData?.attributes?.country_code) +
      (user?.attributes?.mobile ||
        phoneDetails?.mobile ||
        newData?.attributes?.mobile)
    ).slice(1);
    setItem(
      LOCAL_STORAGE_CONSTANT.SESSION,
      JSON.stringify({ ...session, uid: session.uid }),
    );
    if (callback) {
      callback();
    }
  } catch (e) {
    yield put(verifyOtpFailed({ error: e, page }));
    createNotification(errorHandler(e));
    errorCallback(e);
  }
}

function* logoutRequest() {
  try {
    removeItem(LOCAL_STORAGE_CONSTANT.USER);
    removeItem(LOCAL_STORAGE_CONSTANT.SESSION);
  } catch (e) {
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* verifyOTPRequest({
  payload: { data, callback, page, plan_id, errorCallback },
}) {
  const { user } = yield select(state => state.auth);
  const newUser = user?.attributes?.new_user || false;
  data.new_user = newUser;
  const urlParams = new URLSearchParams(window.location.search);
  const uid = urlParams.get('uid');
  const provider = urlParams.get('provider');
  const social_token = urlParams.get('access_token');
  const id = urlParams.get('id');
  const isAppleLogin = getItem('isAppleLogin');
  const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
  const isFromLogin = getItem('isFromLogin');
  // const isFromCoursePage = getItem('isFromCoursePage');
  let completeOnboarding = '';

  try {
    const response = yield call(otpPostRequest, data, plan_id);
    const user = response?.data?.response?.data;
    // if ((!provider || !isAppleLogin) && !isFromCoursePage && user?.attributes?.onboarding_completed) {
    //   user.attributes.onboarding_completed = true;
    // }
    if (isFromLogin === 'false') {
      completeOnboarding = extractJSON('completeOnboarding');
    }
    const socialLoginData = JSON.parse(localStorage.getItem('SocialLoginData'));

    const SocialOnboarding = {
      ...socialLoginData,
      name: completeOnboarding?.name || user?.attributes?.name || '',
      email: user?.attributes?.email || uid || session?.uid || '',
      token: social_token || session?.access_token || '',
      user_profile_attributes: {
        goal: '',
        tried_solutions: '',
        exercise_frequency: '',
        time_per_day: '',
        preferred_part_of_day: '',
      },
    };
    if (user) {
      setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(user));
      yield put(doSignupSuccess({ data: user, page }));
      setItem(
        LOCAL_STORAGE_CONSTANT.SESSION,
        JSON.stringify(response?.headers),
      );
      // if ((!provider || !isAppleLogin) && !isFromCoursePage) {
      //   yield call(onboardingCompleteRequest);
      // }
      // if (isFromLogin === 'true') {    // commented for JW-266
      // if (isFromLogin === 'false') {    // commented for JW-266
      yield call(
        updateUserProfileRequest,
        provider || isAppleLogin ? id : user.id,
        provider || isAppleLogin
          ? SocialOnboarding
          : completeOnboarding
          ? {
              ...completeOnboarding,
              email: user?.attributes?.email || completeOnboarding.email,
            }
          : SocialOnboarding,
      );
      // }
      // const onboardingCompleted = user?.attributes?.onboarding_completed;
      // if (onboardingCompleted) {
      //   yield put(doPlaybackHistoryRequest({ callback }));
      // } else {
      //   callback();
      // }

      callback();
    }
    yield put(verifyOtpSuccess(user));
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Verification Complete !',
    });
  } catch (e) {
    yield put(verifyOtpFailed({ error: e, page }));
    createNotification(errorHandler(e));
    errorCallback(e);
  }
}

function* resendOTPRequest({ payload: { data, callback } }) {
  try {
    const response = yield call(otpResendPostRequest, data);
    yield put(doOtpResendSuccess(response?.data?.response?.data));
    if (response?.data?.response?.data?.attributes?.has_access) {
      setItem(
        LOCAL_STORAGE_CONSTANT.USER,
        JSON.stringify(response?.data?.response?.data),
      );
      setItem(
        LOCAL_STORAGE_CONSTANT.SESSION,
        JSON.stringify(response?.headers),
      );
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Verification Code Sent Successfully !',
    });
    if (callback) {
      callback();
    }
  } catch (e) {
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* surveyRequest({ payload: { data, callback } }) {
  try {
    const response = yield call(surveyPostRequest, data);
    yield put(doSurveySuccess(response?.data?.response?.data));
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Survey Submitted Successfully !',
    });
    setItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS, `${SURVEY_STATUS.DONE}`);
    if (callback) {
      callback();
    }
  } catch (e) {
    yield put(doSurveySuccess({}));
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* waitlistSurveyRequest() {
  try {
    const response = yield call(waitlistSurveyGetRequest);
    yield put(doWaitlistSurveySuccess(response.data.response.data));
  } catch (e) {
    if (e?.response?.status !== 404) {
      createNotification(errorHandler(e));
    }
  } finally {
    yield put(setLoadingState(false));
  }
}

function* singupWithApple({ payload: { response, callback } }) {
  const { code, id_token } = response?.authorization || {};
  const name = response?.user?.name
    ? response?.user?.name?.firstName + ' ' + response?.user?.name?.lastName
    : '';
  try {
    const res = yield call(appleSignInRequest, code, id_token, name);
    const user = res?.data?.response?.data;
    // user.attributes.onboarding_completed = false;
    if (user) {
      setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(user));
      setItem(LOCAL_STORAGE_CONSTANT.SESSION, JSON.stringify(res?.headers));
      // const onboardingCompleted = user?.attributes?.onboarding_completed;
      // if (onboardingCompleted) {
      //   yield put(doPlaybackHistoryRequest({ callback }));
      // } else {
      //   callback();
      // }
      callback();
    }
  } catch (error) {
    createNotification(errorHandler(error));
  }
}

function* resetPasswordOtpRequest({
  payload: { data, callback, errorCallback },
}) {
  try {
    yield put(setLoadingState(true));
    const response = yield call(ResetPassOtpRequest, {
      email: data,
    });
    console.log('response', response);

    if (callback) {
      callback();
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Verification Code Sent Successfully !',
    });
  } catch (e) {
    errorCallback();
    console.error(e?.response);
    // createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* verifyResetPassOtp({
  payload: { data, callback, errorCallback = null },
}) {
  try {
    yield put(setLoadingState(true));
    const response = yield call(verifyResetOtp, data);
    console.log('response', response);

    if (callback) {
      callback();
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'OTP Verified !',
    });
  } catch (e) {
    if (errorCallback) {
      errorCallback();
    }

    doSignupFailed({ error: e });
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* resetNewPassword({ payload: { data, callback } }) {
  try {
    yield put(setLoadingState(true));
    const response = yield call(resetPassword, data);
    if (callback) {
      callback();
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: response?.data?.message || 'Password Reset Successfully !',
    });
  } catch (e) {
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* mergeSendOtpRequest({ payload: { data, callback } }) {
  try {
    yield put(setLoadingState(true));
    const response = yield call(mergeOtpPostRequest, data);
    console.log('response', response);

    if (callback) {
      callback();
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Verification Code Sent Successfully !',
    });
  } catch (e) {
    doSignupFailed({
      error: e,
    });
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* verifyOtpMergeAccounts({
  payload: { data, callback, errorCallback },
}) {
  try {
    yield put(setLoadingState(true));
    const response = yield call(handleverifyOtpMergeAccounts, data);
    const userData = response?.data?.response?.data;

    if (userData) {
      setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(userData));
      // yield put(doSignupSuccess({ data: userData, page: 'login' }));
      // yield put(doGetUserDataSuccess(userData));
    }

    if (callback) {
      callback();
    }
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Accounts Merge Complete !',
    });
  } catch (e) {
    if (errorCallback) {
      errorCallback();
    }

    doSignupFailed({
      error: e,
    });
    createNotification(errorHandler(e));
  } finally {
    yield put(setLoadingState(false));
    yield put(setUniversalLoading(false));
  }
}

/**
 * Watch auth actions
 * */
export default function* authSaga() {
  yield all([
    takeLatest(DO_SIGNUP_REQUEST, signupRequest),
    takeLatest(DO_UPDATE_EMAIL_WITH_OTP_REQUEST, UpdateMobileOtpRequest),
    takeLatest(DO_VERIFY_OTP, otpVerifyRequest),
    takeLatest(DO_LOGIN_REQUEST, loginRequest),
    takeLatest(DO_LOGOUT_REQUEST, logoutRequest),
    takeLatest(VERIFY_OTP_REQUESTED, verifyOTPRequest),
    takeLatest(DO_OTP_RESEND_REQUEST, resendOTPRequest),
    takeLatest(DO_SURVEY_REQUEST, surveyRequest),
    takeLatest(DO_WAITLIST_SURVEY_REQUEST, waitlistSurveyRequest),
    takeLatest(DO_APPLE_SIGNIN_REQUEST, singupWithApple),
    takeLatest(DO_SEND_OTP_REQUEST, resetPasswordOtpRequest),
    takeLatest(DO_VERIFY_RESET_PASS_OTP, verifyResetPassOtp),
    takeLatest(DO_RESET_PASSWORD_REQUEST, resetNewPassword),
    takeLatest(DO_MERGE_SEND_OTP_REQUEST, mergeSendOtpRequest),
    takeLatest(DO_VERIFY_OTP_AND_MERGE_ACCOUNTS, verifyOtpMergeAccounts),
  ]);
}
